export default function accountMenu() {
    const accountMenuActive = document.querySelector('.account-menu__tab.is-active') as HTMLElement;
    accountMenuActive?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
